import React, { useState, useEffect } from 'react';
import { FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { sendApiRequest } from '../utils.js';

const ListInvoices = () => {
  const userData = useSelector(state => state.user_info[0]?.user);
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReceipts = async () => {
      try {
        const response = await sendApiRequest(`api/packages/all_manual/receipts?partnerEmail=${userData.email}`, {}, "GET");
        setReceipts(response.data.data.receipts);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching receipts');
        setLoading(false);
      }
    };

    fetchReceipts();
  }, [userData?.email]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Separate receipts into commission and business
  const commissionReceipts = receipts.filter(receipt => receipt.isCommissionReceipt === true);
  const businessReceipts = receipts.filter(receipt => receipt.isCommissionReceipt === false);

  // Common table rendering function
  const renderTable = (data, title, emptyMessage) => (
    // console.log(data)
    <div className="mb-8">
      <div className="bg-gradient-to-r from-[#13407e] to-[#0d61b5] text-white px-4 sm:px-6 py-3 sm:py-4 rounded-t-lg">
        <h2 className="text-lg sm:text-xl font-semibold">{title}</h2>
      </div>
      <div className="overflow-x-auto bg-white rounded-b-lg shadow-xl border border-[#25b2da]/20">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider">Sr.No</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider">Receipt Number</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider">Receipt date</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider hidden sm:table-cell">Package Title</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider">Amount</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-center text-xs font-medium text-[#13407e] uppercase tracking-wider">Actions</th>
              <th className="px-3 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-[#13407e] uppercase tracking-wider hidden md:table-cell">Type</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data.length > 0 ? (
              data.map((invoice, index) => (
                <tr key={invoice._id} className="hover:bg-gray-50">
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{index + 1}</td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{invoice.receiptNumber}</td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{invoice.receiptDate.split('T')[0]}</td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900 hidden sm:table-cell">{invoice.package?.title}</td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900">{invoice.amount.toFixed(2)}</td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-center">
                    <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                      <Link to={`/dashboard/packages/view-receipt?receiptId=${invoice._id}`} className="text-[#0d61b5] hover:text-[#13407e]">
                        <FaPrint size={16} className="sm:w-5 sm:h-5" />
                      </Link>
                    </div>
                  </td>
                  <td className="px-3 sm:px-6 py-2 sm:py-4 whitespace-nowrap hidden md:table-cell">
                    <span className={`px-2 sm:px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      invoice.isCommissionReceipt 
                        ? 'bg-purple-100 text-purple-800' 
                        : 'bg-blue-100 text-blue-800'
                    }`}>
                      {invoice.isCommissionReceipt ? 'Commission' : 'Business'}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
                  {emptyMessage}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#49c2c7]/5 via-[#25b2da]/10 to-[#0d61b5]/5 py-4 sm:py-6 md:py-8">
      <div className="container mx-auto px-3 sm:px-4 md:px-6">
        {/* Commission Receipts Table */}
        {renderTable(
          commissionReceipts,
          "Commission Receipts",
          "No commission receipts found"
        )}

        {/* Business Receipts Table */}
        {renderTable(
          businessReceipts,
          "Business Receipts",
          "No business receipts found"
        )}
      </div>
    </div>
  );
};

export default ListInvoices;